import {
  List,
  Datagrid,
  TextField,
  ArrayField,
  DateField,
  ReferenceField,
} from "react-admin";

import LayoutContainer from "../components/LayoutContainer";

const TierList = (props) => {
  return (
    <LayoutContainer>
      <List
        {...props}
        //filters={<ProductFilter />}
        perPage={10}
        bulkActionButtons={false}
      >
        <Datagrid rowClick="show">
          <TextField source="code" />
          <TextField source="desc" />
          <ArrayField source="products">
            <Datagrid>
              <ReferenceField
                label="Name"
                source="product_id"
                reference="products"
              >
                <TextField source="name" />
              </ReferenceField>
              <TextField source="qty" />
              <TextField source="location" />
            </Datagrid>
          </ArrayField>
          <DateField source="supplier.name" />
          <DateField source="time" />
        </Datagrid>
      </List>
    </LayoutContainer>
  );
};
/**
 * <ReferenceManyField
          label="Amount"
          target="product_id"
          reference="stock"
        >
          <SingleFieldList>
            <ChipField source="remaining" />
          </SingleFieldList>
        </ReferenceManyField>
 */
export default TierList;
